import { useState, useEffect, useCallback } from 'react';
import { MESSAGE_TYPE, useFloatMessage } from './../../../Providers/FloatMessage'


const STORAGE_KEY_MSG_QUEUE = 'messages_queue_v1'

const UseMessagePlayer = (actions) => {
    const { showMessage } = useFloatMessage()

    // --- ESTADOS ---
    const [isLive, setIsLive] = useState(false);
    const [isPlaying, setIsPlaying] = useState(false);
    const [autoPlayInterval, setAutoPlayInterval] = useState(5000); // 5 seg default
    
    // Eliminamos 'progress' y refs de animación compleja
    const [projectionStatus, setProjectionStatus] = useState("Fuera del aire");

    // Carga inicial de la fila
    const [queue, setQueue] = useState(() => {
        try {
            const saved = localStorage.getItem(STORAGE_KEY_MSG_QUEUE);
            return saved ? JSON.parse(saved) : [];
        } catch { return []; }
    });

    const [currentIndex, setCurrentIndex] = useState(0);

    // Persistencia
    useEffect(() => {
        localStorage.setItem(STORAGE_KEY_MSG_QUEUE, JSON.stringify(queue));
    }, [queue]);

    // --- GESTIÓN DE FILA ---
    const addToQueue = useCallback((item) => {
        const queueItem = { ...item, _qid: Date.now() + Math.random() };
        setQueue(prev => [...prev, queueItem]);
        showMessage({ type: MESSAGE_TYPE.SUCCESS, text: 'Agregado a la fila' });
    }, [showMessage]);

    const removeFromQueue = useCallback((index) => {
        setQueue(prev => {
            const newQ = prev.filter((_, i) => i !== index);
            if (index < currentIndex) setCurrentIndex(c => c - 1);
            else if (index === currentIndex && newQ.length > 0) {
                setIsPlaying(false); // Detener si borramos el que suena
            }
            return newQ;
        });
    }, [currentIndex]);

    const clearQueue = useCallback(() => {
        setQueue([]);
        setCurrentIndex(0);
        setIsPlaying(false);
    }, []);

    const reorderQueue = useCallback((fromIdx, toIdx) => {
        if (toIdx < 0 || toIdx >= queue.length) return;
        setQueue(prev => {
            const list = [...prev];
            const [moved] = list.splice(fromIdx, 1);
            list.splice(toIdx, 0, moved);
            if (currentIndex === fromIdx) setCurrentIndex(toIdx);
            else if (currentIndex === toIdx) setCurrentIndex(fromIdx);
            return list;
        });
    }, [queue, currentIndex]);

    // --- PROYECCIÓN ---
    const projectCurrent = useCallback(async (idx) => {
        const item = queue[idx];
        if (!item) return;

        setProjectionStatus(`Proyectando: #${item.id}`);
        try {
            await actions.sendToScreen(item);
        } catch (error) {
            console.error(error);
            setIsPlaying(false); // Detener si falla
        }
    }, [queue, actions]);

    // --- CONTROLES DE REPRODUCCIÓN ---
    
    // 1. GO LIVE (Solo enciende el switch, NO proyecta)
    const toggleLive = async () => {
        if (isLive) {
            // Apagar
            setIsLive(false);
            setIsPlaying(false);
            setProjectionStatus("Fuera del aire");
            await actions.clearScreen();
        } else {
            // Encender (Modo Standby)
            if (queue.length === 0) {
                showMessage({ type: MESSAGE_TYPE.WARNING, text: 'La fila está vacía.' });
                return;
            }
            setIsLive(true);
            setProjectionStatus("En vivo (Esperando acción...)");
            // AJUSTE SOLICITADO: NO llamamos a projectCurrent aquí.
        }
    };

    // 2. PLAY / PAUSE
    const togglePlay = () => {
        if (!isLive) {
            showMessage({ type: MESSAGE_TYPE.WARNING, text: 'Debes activar la transmisión primero.' });
            return;
        }
        
        const newPlayingState = !isPlaying;
        setIsPlaying(newPlayingState);

        if (newPlayingState) {
            // Si damos Play, proyectamos el actual inmediatamente
            projectCurrent(currentIndex);
        }
    };

    const playNext = useCallback(() => {
        if (currentIndex + 1 >= queue.length) {
            setIsPlaying(false);
            showMessage({ type: MESSAGE_TYPE.INFO, text: 'Fin de la lista.' });
            return;
        }
        const nextIdx = currentIndex + 1;
        setCurrentIndex(nextIdx);
        
        if (isLive) projectCurrent(nextIdx);
    }, [currentIndex, queue.length, isLive, showMessage, projectCurrent]);

    const playPrev = useCallback(() => {
        if (currentIndex > 0) {
            const prevIdx = currentIndex - 1;
            setCurrentIndex(prevIdx);
            if (isLive) projectCurrent(prevIdx);
        }
    }, [currentIndex, isLive, projectCurrent]);

    const jumpTo = (index) => {
        setCurrentIndex(index);
        if (isLive) {
            // Si saltamos manualmente, proyectamos de inmediato (aunque esté en pausa)
            projectCurrent(index);
        }
    };

    // --- MOTOR DE TIEMPO SIMPLE (setInterval) ---
    // Esto reemplaza al requestAnimationFrame. Mucho más ligero.
    useEffect(() => {
        let intervalId;

        if (isLive && isPlaying) {
            intervalId = setInterval(() => {
                playNext();
            }, autoPlayInterval);
        }

        return () => {
            if (intervalId) clearInterval(intervalId);
        };
    }, [isLive, isPlaying, autoPlayInterval, playNext]);

    return {
        isLive, isPlaying, queue, currentIndex, projectionStatus, autoPlayInterval,
        addToQueue, removeFromQueue, clearQueue, reorderQueue,
        toggleLive, togglePlay, playNext, playPrev, jumpTo, setAutoPlayInterval
    };
};


export { UseMessagePlayer };








// import { useState, useRef, useEffect, useCallback } from 'react'

// import { MESSAGE_TYPE, useFloatMessage } from './../../../Providers/FloatMessage'


// const STORAGE_KEY_MSG_QUEUE = 'messages_queue_v1'

// const UseMessagePlayer = (actions, showMessage) => {
//     // --- ESTADOS ---
//     const [isLive, setIsLive] = useState(false);
//     const [isPlaying, setIsPlaying] = useState(false);
//     const [autoPlayInterval, setAutoPlayInterval] = useState(5000); // 5 seg default
//     const [progress, setProgress] = useState(0);
//     const [projectionStatus, setProjectionStatus] = useState("Esperando...");

//     // Carga inicial de la fila desde LocalStorage
//     const [queue, setQueue] = useState(() => {
//         try {
//             const saved = localStorage.getItem(STORAGE_KEY_MSG_QUEUE);
//             return saved ? JSON.parse(saved) : [];
//         } catch { return []; }
//     });

//     const [currentIndex, setCurrentIndex] = useState(0);

//     // Refs para el Timer
//     const startTimeRef = useRef(null);
//     const animationFrameRef = useRef(null);

//     // Persistencia
//     useEffect(() => {
//         localStorage.setItem(STORAGE_KEY_MSG_QUEUE, JSON.stringify(queue));
//     }, [queue]);

//     // --- GESTIÓN DE FILA ---
//     const addToQueue = useCallback((item) => {
//         // Agregamos un ID único de fila (_qid) para permitir duplicados si se desea
//         const queueItem = { ...item, _qid: Date.now() + Math.random() };
//         setQueue(prev => [...prev, queueItem]);
//         showMessage({ type: MESSAGE_TYPE.SUCCESS, text: 'Agregado a la fila exitosamente' });
//     }, [showMessage]);

//     const removeFromQueue = useCallback((index) => {
//         setQueue(prev => {
//             const newQ = prev.filter((_, i) => i !== index);
//             // Ajustar índice si borramos el actual o uno anterior
//             if (index < currentIndex) setCurrentIndex(c => c - 1);
//             else if (index === currentIndex && newQ.length > 0) {
//                 // Si borramos el que suena, pausamos o reiniciamos
//                 setIsPlaying(false);
//                 setProgress(0);
//             }
//             return newQ;
//         });
//     }, [currentIndex]);

//     const clearQueue = useCallback(() => {
//         setQueue([]);
//         setCurrentIndex(0);
//         setIsPlaying(false);
//         setProgress(0);
//     }, []);

//     const reorderQueue = useCallback((fromIdx, toIdx) => {
//         if (toIdx < 0 || toIdx >= queue.length) return;
//         setQueue(prev => {
//             const list = [...prev];
//             const [moved] = list.splice(fromIdx, 1);
//             list.splice(toIdx, 0, moved);
            
//             // Ajustar el índice actual si movemos la canción que está sonando
//             if (currentIndex === fromIdx) setCurrentIndex(toIdx);
//             else if (currentIndex === toIdx) setCurrentIndex(fromIdx);
            
//             return list;
//         });
//     }, [queue, currentIndex]);

//     // --- PROYECCIÓN ---
//     const projectCurrent = useCallback(async (idx) => {
//         const item = queue[idx];
//         if (!item) return;

//         setProjectionStatus(`Proyectando: #${item.id}`);
//         try {
//             await actions.sendToScreen(item);
//         } catch (error) {
//             showMessage({ type: MESSAGE_TYPE.BAD, text: error });
//             //console.error(error);
//             setIsPlaying(false);
//         }
//     }, [queue, actions]);

//     // --- CONTROLES DE REPRODUCCIÓN ---
//     const toggleLive = async () => {
//         if (isLive) {
//             setIsLive(false);
//             setIsPlaying(false);
//             setProgress(0);
//             setProjectionStatus("Pantalla Limpia");
//             await actions.clearScreen();
//         } else {
//             if (queue.length === 0) {
//                 showMessage({ type: MESSAGE_TYPE.WARNING, text: 'La fila está vacía' });
//                 return;
//             }
//             setIsLive(true);
//             // Proyectar el actual inmediatamente
//             projectCurrent(currentIndex);
//         }
//     };

//     const togglePlay = () => {
//         if (!isLive) {
//             showMessage({ type: MESSAGE_TYPE.WARNING, text: 'Debes activar LIVE primero' });
//             return;
//         }
//         setIsPlaying(!isPlaying);
//         startTimeRef.current = null; // Reset timer ref
//     };

//     const playNext = useCallback(() => {
//         if (currentIndex + 1 >= queue.length) {
//             setIsPlaying(false);
//             setProgress(0);
//             showMessage({ type: MESSAGE_TYPE.INFO, text: 'Fin de la lista' });
//             return;
//         }
//         const nextIdx = currentIndex + 1;
//         setCurrentIndex(nextIdx);
//         setProgress(0);
//         startTimeRef.current = null;
//         if (isLive) projectCurrent(nextIdx);
//     }, [currentIndex, queue.length, isLive, showMessage, projectCurrent]);

//     const playPrev = useCallback(() => {
//         if (currentIndex > 0) {
//             const prevIdx = currentIndex - 1;
//             setCurrentIndex(prevIdx);
//             setProgress(0);
//             startTimeRef.current = null;
//             if (isLive) projectCurrent(prevIdx);
//         }
//     }, [currentIndex, isLive, projectCurrent]);

//     const jumpTo = (index) => {
//         setCurrentIndex(index);
//         setProgress(0);
//         startTimeRef.current = null;
//         if (isLive) projectCurrent(index);
//     };

//     // --- MOTOR DE TIEMPO (LOOP) ---
//     useEffect(() => {
//         if (!isLive || !isPlaying) {
//             if (animationFrameRef.current) cancelAnimationFrame(animationFrameRef.current);
//             return;
//         }

//         const loop = (timestamp) => {
//             if (!startTimeRef.current) startTimeRef.current = timestamp;
//             const elapsed = timestamp - startTimeRef.current;
            
//             // Calcular porcentaje
//             let pct = (elapsed / autoPlayInterval) * 100;
//             if (pct > 100) pct = 100;
//             setProgress(pct);

//             if (elapsed >= autoPlayInterval) {
//                 startTimeRef.current = null;
//                 playNext(); // Pasa al siguiente
//             } else {
//                 animationFrameRef.current = requestAnimationFrame(loop);
//             }
//         };

//         animationFrameRef.current = requestAnimationFrame(loop);
//         return () => { if (animationFrameRef.current) cancelAnimationFrame(animationFrameRef.current); };
//     }, [isLive, isPlaying, autoPlayInterval, playNext]);

//     return {
//         isLive, isPlaying, queue, currentIndex, progress, projectionStatus, autoPlayInterval,
//         addToQueue, removeFromQueue, clearQueue, reorderQueue,
//         toggleLive, togglePlay, playNext, playPrev, jumpTo, setAutoPlayInterval
//     };
// };

// export { UseMessagePlayer };